export interface VideoCallDto {
  id: string
  conversation_id: string
  date_completed: string | null
  call_status: VideoCallStatusType
  date_created: string
  date_modified: string
  participants: VideoCallParticipantDto[]
}

export enum VideoCallStatusType {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
}

export interface VideoCallParticipantDto {
  user_id: string
  user_public_id: string
  status: VideoCallParticipantStatusType
}

export enum VideoCallParticipantStatusType {
  Invited = 'INVITED',
  Declined = 'DECLINED',
  Missed = 'MISSED',
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
}

export type VideoCallConnectionDescriptorDto = TwilioCallConnectionDescriptorDto

export interface TwilioCallConnectionDescriptorDto {
  type: 'Twilio'
  token: string
  room_name: string
}

interface VideoCallParticipantIdentityPayload {
  user_id: string
  user_public_id: string
}

export interface StartVideoCallPayload {
  conversation_id: string
  invitee_identities: VideoCallParticipantIdentityPayload[]
}

export interface StartVideoCallResponse {
  call: VideoCallDto
  call_connection_descriptor: VideoCallConnectionDescriptorDto
}

export interface JoinVideoCallResponse {
  call_connection_descriptor: VideoCallConnectionDescriptorDto
}

export type VideoCallEventsDto =
  | VideoCallStartedEvent
  | VideoCallParticipantJoinedEvent
  | VideoCallParticipantInvitedEvent
  | VideoCallParticipantConnectedEvent
  | VideoCallParticipantDisconnectedEvent
  | VideoCallParticipantDeclinedEvent
  | VideoCallParticipantMissedEvent
  | VideoCallCompletedEvent

export interface VideoCallStartedEvent {
  type: 'CALL_STARTED'
  payload: VideoCallDto
}

export interface VideoCallParticipantInvitedEvent {
  type: 'CALL_PARTICIPANT_INVITED'
  payload: {
    id: string
    participant_user_id: string
    participant_public_user_id: string
    date_invited: string
  }
}

export interface VideoCallParticipantDeclinedEvent {
  type: 'CALL_PARTICIPANT_DECLINED'
  payload: {
    id: string
    participant_user_id: string
    participant_public_user_id: string
    date_declined: string
  }
}

export interface VideoCallParticipantMissedEvent {
  type: 'CALL_PARTICIPANT_MISSED'
  payload: {
    id: string
    participant_user_id: string
    participant_public_user_id: string
    date_missed: string
  }
}

export interface VideoCallParticipantJoinedEvent {
  type: 'CALL_PARTICIPANT_JOINED'
  payload: {
    id: string
    participant_user_id: string
    participant_public_user_id: string
    date_joined: string
  }
}

export interface VideoCallParticipantConnectedEvent {
  type: 'CALL_PARTICIPANT_CONNECTED'
  payload: {
    id: string
    participant_user_id: string
    participant_public_user_id: string
    date_connected: string
  }
}

export interface VideoCallParticipantDisconnectedEvent {
  type: 'CALL_PARTICIPANT_DISCONNECTED'
  payload: {
    id: string
    participant_user_id: string
    participant_public_user_id: string
    date_disconnected: string
  }
}

export interface VideoCallCompletedEvent {
  type: 'CALL_COMPLETED'
  payload: {
    id: string
    date_completed: string
  }
}
